import moment from "moment";
import platform from "Pub/js/platform";
const { LocalToDongbaTime } = platform;
/**
 * 为全局添加业务信息
 * 如： 业务日期 业务集团信息 用户id 用户名称 集团id 集团名称 用户编码
 * @param {Object} data
 * {String} businessDate 业务日期
 * {String} userId 用户id
 * {String} userName 用户名称
 * {String} groupId 集团id
 * {String} groupName 集团名称
 * {String} userCode 用户编码
 * {String} projectCode 项目编码
 */
const BusinessInfoController = callback => data => {
    window.GETBUSINESSINFO = (config) => {
        if (!config){
            return data;
        }else{
            let { 
                businessDateCurrentTime //获取当前客户端时分秒的业务日期
             } = config;
            let newData = {...data};
            if (businessDateCurrentTime === true){
                let dongbaTime = LocalToDongbaTime(moment()).format('HH:mm:ss'); //转成东八时区
                newData.businessDate = `${moment(newData.businessDate).format('YYYY-MM-DD')} ${dongbaTime}`;
            }
            return newData;
        }
    };
    // 允许加载应用页面
    callback(true);
};

export default BusinessInfoController;
